import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { taxRepository } from '../data-access/repositories/TaxRepository'

const base = ['tax']

/**
 * Partial keys for invalidation (ADR-5): command models invalidate through
 * these instead of inlining key arrays.
 */
export const taxQueryKeys = {
  list: buildQueryKey([...base, 'list']),
}

export const taxQueryConfig = {
  getTax: (id: number) => ({
    queryKey: buildQueryKey([...base, id]),
    queryFn: () => taxRepository.getTax(id),
  }),
  getTaxesSelect: () => ({
    queryKey: buildQueryKey(['selects', 'taxes']),
    queryFn: () => taxRepository.getTaxes({ pageSize: 999 }),
  }),
  list: (params: { isActive: boolean; page: number; pageSize: number }) => ({
    queryKey: buildQueryKey([...base, 'list', params]),
    queryFn: () => taxRepository.getTaxes(params),
  }),
}
